import { List } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useCarrierEngagementFilters } from '../../contexts/CarrierEngagementFilterContext';

// Model type = the referral line of business. Medical/Pharmacy exist in real
// data today; Dental is a valid value that currently matches no rows. "All"
// clears the filter.
const MODEL_TYPE_FILTERS = ['All', 'Medical', 'Pharmacy', 'Dental'];
const HCC_FILTERS = ['All', 'Exclude HCC', 'HCC Only'];

function FilterPillGroup({ ariaLabel, testId, options, selected, onChange }) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      data-testid={testId}
      className="grid h-[30px] rounded-lg border border-border overflow-hidden bg-card divide-x divide-border w-full"
      style={{ gridTemplateColumns: `65px repeat(${options.length - 1}, minmax(0, 1fr))` }}
    >
      {options.map((label, i) => {
        const isAll = i === 0;
        const isSelected = selected === label;
        return (
          <button
            key={label}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onChange(label)}
            className={cn(
              'inline-flex items-center justify-center gap-1.5 px-3 text-[12px] font-medium transition-colors',
              isSelected
                ? 'bg-filter-bg-active text-filter-text-active'
                : 'bg-white text-foreground hover:bg-muted/40'
            )}
          >
            {isAll && <List className="h-3.5 w-3.5" />}
            {label}
          </button>
        );
      })}
    </div>
  );
}

/**
 * Stacked product + HCC pill rows. Sized so the two rows plus the gap between
 * them sum to 68px — the same height as the workflow chevron bar — so the
 * pills align top/bottom with the chevron when both live in the TopBar.
 */
function CarrierEngagementFilterPills() {
  const { modelType, setModelType, hcc, setHcc } = useCarrierEngagementFilters();

  return (
    <div
      data-testid="carrier-engagement-pills"
      className="flex flex-col gap-1 shrink-0 w-[320px]"
    >
      <FilterPillGroup
        ariaLabel="Model Type filter"
        testId="model-type-filter-group"
        options={MODEL_TYPE_FILTERS}
        selected={modelType}
        onChange={setModelType}
      />
      <FilterPillGroup
        ariaLabel="HCC filter"
        testId="hcc-filter-group"
        options={HCC_FILTERS}
        selected={hcc}
        onChange={setHcc}
      />
    </div>
  );
}

export { CarrierEngagementFilterPills };
